import React from "react";
import * as Styles from "./button.styles";

interface DefaultButtonI {
  content: any;
  onClick?: () => void;
  disabled?: boolean;
  style?: any;
  type?: "button" | "submit" | "reset" | undefined;
}

export function DefaultButton(props: DefaultButtonI) {
  return (
    <Styles.DefaultButton
      disabled={props.disabled}
      onClick={props.disabled ? () => {} : props.onClick}
      style={{ ...props.style }}
      type={props.type ?? "button"}
    >
      {props.content}
    </Styles.DefaultButton>
  );
}
